module.exports = __webpack_public_path__ + "img/contact.d12411e1.jpg";